import React from 'react'
import Fragment from '../common/fragment'

function FragmentDD(props) {
  return (
    <Fragment pos="dddd" {...props}>
      <p className="interact interactive" id="anchor-zoom-c">
      Aire envasado. Humo envasado. Dolor envasado. Ríos, corrientes y ventiscas
envasadas. Angustia y alegría. Aire de París. Canto de pájaros, zumbido de abejas.
Flautas. Salamanca envasada. Refinería envasada. La Palabra de Dios envasada.
Babilonia y Salamanca. Primeras ciudades de Mesoamérica y trenes de Guanajuato.
Muñeco envasado, sin aire. Negro envasado y luz transparente de las botellas y los
envases. Cristal y geometría. Ceguera. Agonías envasadas al mejor postor.
Duchamp envasado, pálido y entumecido. Arte contemporáneo. Teatro. Readymade.
Ardor y chimeneas.
      </p>
    </Fragment>
  )
}


export default FragmentDD
